/**
 * API 서버 주소는 **빌드 환경**이 정한다 — 키오스크·고객 앱과 같은 규칙이다.
 *
 *   npm start      →  .env.development  →  테스트 서버 3.38.75.141
 *   npm run build  →  .env.production   →  운영 서버 api.zerosalon.co.kr
 *
 * 🔴 예전에는 이 파일에 `const __DEV__ = false;` 가 박혀 있어서
 *    **로컬에서 npm start 해도 운영 API 에 붙었다.**
 *    본사 콘솔은 회원 포인트 지급·기기 삭제·지점 삭제까지 되는 화면이라,
 *    개발 중 저장 버튼 한 번이 그대로 실회원 데이터에 반영됐다.
 *    (dev 주소도 192.168.0.19 라는 옛 개발자 로컬 IP 여서 살아있지도 않았다)
 *
 * 특정 서버를 강제하려면 실행할 때 덮어쓴다:
 *   REACT_APP_API_HOST=http://localhost:9000 npm start
 */
const development = {
  API_HOST: 'http://3.38.75.141:9000',
  SECRET: 'zJMCmm2dD07byLasLtBbQ4e2hLIqEM0D',

  LANDING_PAGE_URL: 'http://www.zerosalon.co.kr/',
};

/**
 * 🔴 https 다. `:9000` 평문 직결이 아니다 (2026-09-01)
 *
 * 콘솔 페이지가 https 로 열리므로 API 도 https 여야 한다 —
 * https 페이지에서 http 를 부르면 **브라우저가 mixed content 로 차단**해서
 * 콘솔이 아무 데이터도 못 불러온다.
 *
 * ⚠️ https 는 nginx(443) → 127.0.0.1:9000 으로 들어간다. **포트를 붙이지 않는다.**
 * ⚠️ nginx 는 밑줄 헤더를 기본으로 버리는데 우리 인증 헤더가 `access_token` 이다.
 *    `api.zerosalon.co.kr` 에 `underscores_in_headers on;` 이 들어가 있어야 한다(적용됨).
 */
const production = {
  API_HOST: 'https://api.zerosalon.co.kr',
  SECRET: '3SNTv1F59ORHVYljtcJ8xE4aQf2oRxCP',

  LANDING_PAGE_URL: 'http://www.zerosalon.co.kr/',
};

const getEnvVars = () => {
  // CRA 가 넣어주는 값. npm start = 'development', npm run build = 'production'
  const isProduction = process.env.NODE_ENV === 'production';
  const base = isProduction ? production : development;
  const apiHost = process.env.REACT_APP_API_HOST || base.API_HOST;

  console.log(`[config] ${isProduction ? 'PRODUCTION' : 'DEVELOPMENT'} · API_HOST=${apiHost}`);

  return { ...base, API_HOST: apiHost };
};

export default getEnvVars();
